import { Lesson } from '../../api/types/lesson';

/**
 * A lesson belongs on the Transcripts screen when it has an uploaded audio
 * file and no transcript yet (daily and library lessons alike).
 */
export const isTranscriptCandidate = (lesson: Lesson): boolean =>
  !!lesson.audioStreamPath?.trim()?.length && !lesson.lrcTranscript?.trim()?.length;
